import { useNovaEventing } from '@nova/react';
import { AdaptiveCardEvents } from '@office-start/adaptive-card-types';
import { OpenUrlAction, SubmitAction } from 'adaptivecards';
import React, { useMemo } from 'react';
import { AdaptiveCardRenderer } from './AdaptiveCardRenderer';
export var AdaptiveCardNovaComponent = function (props) {
    var novaEventing = useNovaEventing();
    var card = props.card, errorFallbackHandler = props.errorFallbackHandler, hostConfig = props.hostConfig;
    var cardActionsHandler = function (action) {
        if (action instanceof SubmitAction) {
            novaEventing.generateEvent({
                event: AdaptiveCardEvents.onSubmit(function () {
                    return { data: action.data };
                }),
            });
        }
        if (action instanceof OpenUrlAction) {
            novaEventing.generateEvent({
                event: AdaptiveCardEvents.openUrl(function () {
                    return { url: action.url };
                }),
            });
        }
    };
    return useMemo(function () {
        return (React.createElement(AdaptiveCardRenderer, { payload: card, cardActionsHandler: cardActionsHandler, errorFallbackHandler: errorFallbackHandler, hostConfig: hostConfig }));
    }, [card, novaEventing, hostConfig]);
};
//# sourceMappingURL=AdaptiveCardNovaComponent.js.map